import React from 'react'
import classes from './Input.module.sass'
import { ValidationResultInterface } from '../../types/interfaces'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../store/slices/settingsSlice'

type Props = {
  type: string
  value: string | number
  placeHolder?: string
  onChangeHandler: (
    value: string | number | boolean | (string | undefined)[],
    fieldName: string,
    type: string,
  ) => void
  fieldName: string
  itemValidationResult?: ValidationResultInterface
  onBlur?: (fieldName: string) => void
  label?: string,
}

export const Input = ({
  type,
  value,
  placeHolder,
  onChangeHandler,
  fieldName,
  itemValidationResult,
  onBlur,
  label
}: Props) => {
  const darkTheme = useSelector(selectDarkTheme)
  
  return (
    <div className={classes.InputContainer}>
     {label &&   <label className={classes.Label}>{label}</label>}
      <input
        placeholder={placeHolder}
        type={type === 'numberText' ? 'text' : type
         }
           className={
                 itemValidationResult?.isEmptyError && darkTheme
                   ? classes.ContainerRequiredDark
                   : itemValidationResult?.isEmptyError
                   ? classes.ContainerRequired
                   : darkTheme
                   ? classes.ContainerDark
                   : classes.Container
               }
        value={value}
        onChange={(e) => {
          
          onChangeHandler(e.target.value, fieldName, type)
        }}
        onBlur={() => onBlur && onBlur(fieldName)}
      />
      <div className={classes.ValidationErrorField}>
        {itemValidationResult?.isDirty &&
          itemValidationResult?.notValid &&
          itemValidationResult?.errorMessage}
      </div>
    </div>
  )
}
